import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru/translation.json';
import en from './locales/en/translation.json';
import oz from './locales/uz/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      oz: { translation: oz },
      en: { translation: en }
    },
    fallbackLng: 'en', // Если язык не найден, включаем english
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;